export const typeOptions = {
	online: 'Online',
	physical: 'Fysiek'
}
